module.exports = __webpack_public_path__ + "img/scanner.f7aad788.svg";